import styled from "styled-components";

export const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  
  img{
    width: 33%;
  }
`